export default "__VITE_ASSET__f82be8fe__"